import { parseISO as parseISOFns } from 'date-fns';

export default function parseISO(dateString: string): Date {
  // dateString should be defined, but if it's not we default to empty string
  // then date-fns returns 'Invalid Date'.
  // This was the default behavior in date-fns 2.x
  return parseISOFns(dateString || '');
}
